import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ConsentGate } from "@/components/ConsentChoice";
import { TimeSync } from "@/components/TimeSettings";

export const Loader = () => (
  <div className="min-h-screen grid place-items-center" data-testid="page-loader">
    <div className="h-8 w-8 rounded-full border-2 border-[#C86D51] border-t-transparent animate-spin" />
  </div>
);

export function Protected({ children, allowUnboarded }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (!user.onboarded && !allowUnboarded) return <Navigate to="/start" replace />;
  if (user.needs_consent && !allowUnboarded) return <ConsentGate />;
  return <>{children}<TimeSync /></>;
}
